import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';
import NestedFields from 'app/src/elements/NestedFields';

import { CREATE_RECONCILE } from './queries';

export const FIELDS = {
  accountId: {
    label: 'Account',
    rules: { required: true },
  },
  startOn: {
    type: 'date',
    label: 'Start Date',
    rules: { required: true },
  },
  endOn: {
    type: 'date',
    label: 'End Date',
    rules: { required: true },
  },
  startBalance: {
    type: 'decimal',
    label: 'Start Balance',
    rules: { required: true },
  },
  endBalance: {
    type: 'decimal',
    label: 'End Balance',
    rules: { required: true },
  }
}

export const SERVICE_CHARGE_FIELDS = {
  serviceChargeAmount: {
    type: 'decimal',
    label: 'Service Charge'
  },
  serviceChargeDate: {
    type: 'date',
    label: 'Date'
  },
  serviceChargeAccountId: {
    label: 'Expense Account'
  },
}

export const INTEREST_FIELDS = {
  interestAmount: {
    type: 'decimal',
    label: 'Interest Earned'
  },
  interestDate: {
    type: 'date',
    label: 'Date'
  },
  interestAccountId: {
    label: 'Interest Account',
  }
};

export const ADDITIONAL_LINES = {
  serviceChargeAmount: '',
  serviceChargeDate: '',
  serviceChargeAccountId: '',
  interestAmount: '',
  interestDate: '',
  interestAccountId: '',
};

const NewReconcile = ({ setShowModal, refetch, selects }) => {
  const additionalLines = [{...ADDITIONAL_LINES}];
  const [nestedResources, setNestedResources] = useState(additionalLines);
  const [formStatus, setFormStatus] = useState();
  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      nestedFields: [
        {
          nestedResources,
          prefix: 'serviceChargeAttributes',
          fields: SERVICE_CHARGE_FIELDS,
        },
        {
          nestedResources,
          prefix: 'interestAttributes',
          fields: INTEREST_FIELDS,
        }
      ],
    })
  });

  const [createReconcile] = useMutation(CREATE_RECONCILE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    input['serviceChargeAmount'] = input['serviceChargeAttributes'][0].serviceChargeAmount !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeAmount : null
    input['serviceChargeDate'] = input['serviceChargeAttributes'][0].serviceChargeDate !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeDate : null
    input['serviceChargeAccountId'] = input['serviceChargeAttributes'][0].serviceChargeAccountId !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeAccountId : null
    input['interestAmount'] = input['interestAttributes'][0].interestAmount !== '' ?
      input['interestAttributes'][0].interestAmount : null
    input['interestDate'] = input['interestAttributes'][0].interestDate !== '' ?
      input['interestAttributes'][0].interestDate : null
    input['interestAccountId'] = input['interestAttributes'][0].serviceChargeAccountId !== '' ?
      input['interestAttributes'][0].interestAccountId : null
    setFormStatus('submitting');
    createReconcile({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };
  fields.accountId.select = selects.accounts;

  const serviceChargeFields = { ...SERVICE_CHARGE_FIELDS };
  serviceChargeFields.serviceChargeAccountId.select = selects.accounts;

  const interestFields = { ...INTEREST_FIELDS };
  interestFields.interestAccountId.select = selects.accounts;

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <NestedFields
        prefix="serviceChargeAttributes"
        resources={nestedResources}
        fields={serviceChargeFields}
        control={control}
        errors={errors}
      />

      <NestedFields
        prefix="interestAttributes"
        resources={nestedResources}
        fields={interestFields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Reconcile" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewReconcile;
